/* VivaMaison yeni anasayfa etkileşimleri (22 Eki 2026; 26 Eki quick add + shade fiyat + look görünür kare). Her section bu dosyayı çağırır; tek kez çalışır. */
(function () {
  if (window.vmHome) return;
  var SW = {'white':'#F4F1EA','ecru':'#E9DFCB','natural':'#E2D6BE','beige':'#D8C6A8','cream':'#EFE6D2','grey':'#A7A39C','gray':'#A7A39C','anthracite':'#3A3A3A','black':'#222','dark green':'#3E4E3A','sage':'#A8B89A','green':'#6F7F5C','dark red':'#7A2E2A','burgundy':'#6E2A2E','red':'#A2402F','indigo':'#3A4A6B','navy':'#2E3A52','blue':'#6C88A0','brown':'#6B4E36','caramel':'#B07C4A','light pink':'#EBCBC4','powder':'#E8C5C0','pink':'#E2BDB4','terracotta':'#B4613F','mustard':'#C59A3C','khaki':'#9C946B','stone':'#BDB4A4'};
  /* ürün fotoğraflarından gözle doğrulanmış tam eşleşmeler (22 Eki, waffle seti) — önce bunlara bakılır */
  var EXACT = {'dark green':'#3F5A3A','dark red':'#8B3A3C','grey':'#8F8D8B','indigo blue':'#2C4F6E','brown':'#6E5444','caramel':'#B9814B','anthracite':'#44494F','white':'#F2F1EC','sage green':'#9FAE90','pink':'#E2B4AD','natural':'#DCCDB2','black':'#262626',
    /* 23 Eki: varsayılan beje düşen ve yanlış tona eşlenen adlar (ürün fotoğraflarından ölçüldü) */
    'coral':'#E07A68','lilac':'#B79BC8','plum':'#8E6A86','mint':'#B8DED2','yellow':'#E8B43A','orange':'#E39070','wine':'#9A3E4C','rust':'#A9582E','salmon':'#F2A78E','tile':'#E0662F','dark tile':'#D2702F','latte':'#C8B49A','cinnamon':'#A4532F','earth':'#E39A5A','milky coffee':'#C9BBA8','olive green':'#7F7E44','baby blue':'#C8DCEB','hawaii blue':'#8EA4C8','barbie pink':'#E07AA5','pure white':'#F4F4F2','light gray':'#BDBDBD','light beige':'#CFC6BE','light brown':'#C9A06A','dark brown':'#4E3B31','dark gray':'#4A4A4D','charcoal gray':'#48494D','gray':'#8F8D8B','navy':'#2C3F66','navy blue':'#2C3F66','blue':'#5A7FB5','green':'#4F6B3E','burgundy':'#7E3B46','terracotta':'#D9735F','mustard':'#DDA93A','light pink':'#E3C2C8','beige':'#E3D3C2','ecru':'#E9E0D5','cream':'#EEE5D3','stone':'#B5A78F',
    'rainbow':'linear-gradient(135deg,#C8463C 0 20%,#E3A33A 20% 40%,#5E9A6E 40% 60%,#3F6FA8 60% 80%,#8A5A9A 80%)'};
  var one = function (c) { if (EXACT[c]) return EXACT[c]; c = c.replace(/ striped$/, ''); if (EXACT[c]) return EXACT[c]; for (var k in SW) if (c.indexOf(k) > -1) return SW[k]; return '#CFC6B6'; };
  var swatch = function (c) {
    c = (c || '').toLowerCase().trim(); if (EXACT[c]) return EXACT[c];
    var p = c.split(/ - | \/ /);                         /* "White - Burgundy" → iki renkli nokta */
    if (p.length < 2) { var w = c.split(' '); if (w.length === 2 && EXACT[w[0]] && EXACT[w[1]]) p = w; }   /* "Mint Pink", "Green White" */
    return p.length === 2 ? 'linear-gradient(135deg,' + one(p[0]) + ' 50%,' + one(p[1]) + ' 50%)' : one(c);
  };
  var GO = '<svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function once(el, k) { if (el.dataset[k]) return false; el.dataset[k] = '1'; return true; }

  function dots(root) {
    root.querySelectorAll('.vm-dots i[data-c]').forEach(function (i) { if (!i.style.background) i.style.background = swatch(i.dataset.c); });   /* ürüne özel renk (custom.swatches) sunucuda yazıldıysa ezme */
  }
  function reveal(root) {
    root.querySelectorAll('.vm-rv').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });
  }
  function railNav(rail, prev, next, thumb) {
    var step = function () {
      var c = rail.querySelector('.vm-card:not([hidden]),.vm-stile');
      if (!c) return rail.clientWidth;
      var w = c.offsetWidth + 14; return w * Math.max(1, Math.floor(rail.clientWidth / w));
    };
    var upd = function () {
      var max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.disabled = rail.scrollLeft <= 4;
      if (next) next.disabled = rail.scrollLeft >= max - 4;
      if (thumb) {
        var w = max > 0 ? rail.clientWidth / rail.scrollWidth * 100 : 100;
        thumb.style.width = w + '%'; thumb.style.left = (max > 0 ? rail.scrollLeft / max * (100 - w) : 0) + '%';
      }
    };
    if (prev) prev.onclick = function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); };
    if (next) next.onclick = function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); };
    rail.addEventListener('scroll', upd, { passive: true });
    addEventListener('resize', upd);
    upd();
    return upd;
  }

  function best(sec) {
    var rail = sec.querySelector('.vm-rail');
    var upd = railNav(rail, sec.querySelector('[data-prev]'), sec.querySelector('[data-next]'), sec.querySelector('.vm-track i'));
    sec.querySelectorAll('.vm-tabs button').forEach(function (b) {
      b.onclick = function () {
        sec.querySelectorAll('.vm-tabs button').forEach(function (x) { x.setAttribute('aria-selected', x === b); });
        var f = b.dataset.f;
        rail.querySelectorAll('.vm-card').forEach(function (c) { c.hidden = !(f === 'all' || c.dataset.grp === f); });
        rail.scrollLeft = 0; upd();
      };
    });
  }

  function film(sec) {
    var v = sec.querySelector('video'), b = sec.querySelector('.vm-film__play');
    if (!v || !b) return;
    var PAUSE = '<path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/>', PLAY = '<path d="M8 5l11 7-11 7z"/>';
    var userPaused = reduce;
    var sync = function () { b.querySelector('svg').innerHTML = v.paused ? PLAY : PAUSE; b.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video'); };
    v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
    b.onclick = function () { if (v.paused) { userPaused = false; v.play(); } else { userPaused = true; v.pause(); } };
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && !userPaused) v.play().catch(function () {}); else v.pause(); });
    }, { threshold: .35 }).observe(v);
  }

  function shade(sec) {
    var data; try { data = JSON.parse(sec.querySelector('[data-palette]').textContent); } catch (e) { return; }
    var sw = sec.querySelector('.vm-sw'), sr = sec.querySelector('.vm-srail'), nm = sec.querySelector('[data-shade-name]');
    var PR = {}; try { PR = JSON.parse(sec.querySelector('[data-prices]').textContent) || {}; } catch (e) {}   /* 26 Eki: handle → fiyat HTML */
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var upd = railNav(sr, sec.querySelector('[data-prev]'), sec.querySelector('[data-next]'));
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var show = function (k) {
      var p = data.filter(function (x) { return x.n === k; })[0]; if (!p) return;
      sr.classList.add('is-fade');
      setTimeout(function () {
        sr.innerHTML = p.items.map(function (i) {
          var url = root + 'products/' + esc(i.h) + (i.v ? '?variant=' + esc(i.v) : '');
          return '<a class="vm-stile' + (i.w ? ' is-white' : '') + '" href="' + url + '" aria-label="' + esc(i.t + ' in ' + i.c) + '"><span class="vm-stile__img"><img loading="lazy" src="' + esc(i.img) + '?width=700" alt="' + esc(i.t + ', ' + i.c) + '"><span class="vm-stile__go">' + GO + '</span></span><span class="vm-stile__t">' + esc(i.t) + '</span><span class="vm-stile__m">' + (PR[i.h] || '') + '<small>' + esc(i.c) + '</small></span></a>';
        }).join('');
        sr.scrollLeft = 0; sr.classList.remove('is-fade'); upd();
        /* 27 Eki: kırık görsel → /products/<handle>.js ile varyantın güncel görselini al (veri dosyası eskiyebiliyor) */
        sr.querySelectorAll('img').forEach(function (img) {
          img.addEventListener('error', function galeriOnar() {
            img.removeEventListener('error', galeriOnar);
            var a = img.closest('.vm-stile'), h = (a.getAttribute('href') || '').split('/products/')[1] || '', handle = h.split('?')[0], vid = (h.split('variant=')[1] || '').split('&')[0];
            if (!handle) return;
            fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (pj) {
              var v = (pj.variants || []).filter(function (x) { return String(x.id) === vid; })[0];
              var src = (v && v.featured_image && v.featured_image.src) || (pj.featured_image) || '';
              if (src) img.src = src.replace(/^\/\//, 'https://').split('?')[0] + '?width=700';
            }).catch(function () {});
          });
        });
      }, 180);
      nm.textContent = k;
      sw.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.k === k); });
    };
    sw.innerHTML = data.map(function (p) {
      return '<button type="button" data-k="' + esc(p.n) + '" style="background:' + esc(p.hex) + '" aria-label="' + esc(p.n) + '" title="' + esc(p.n) + '" aria-pressed="false"></button>';
    }).join('');
    sw.querySelectorAll('button').forEach(function (b) { b.onclick = function () { show(b.dataset.k); }; });
    if (data[0]) show(data[0].n);
  }

  function look(sec) {
    var g = sec.querySelector('.vm-look__grid'), d = sec.querySelector('.vm-look__dots');
    if (!g || !d) return;
    /* 26 Eki: mobilde gizlenen kare (vm-l1) nokta ve adım hesabına girmez */
    var vis = function () { return Array.prototype.filter.call(g.children, function (f) { return f.offsetWidth > 0; }); };
    var build = function () { d.innerHTML = vis().map(function () { return '<i></i>'; }).join(''); };
    build();
    var u = function () {
      var fs = vis(), f = fs[0]; if (!f) return;
      if (d.children.length !== fs.length) build();
      var i = Math.round(g.scrollLeft / (f.offsetWidth + 10));
      Array.prototype.forEach.call(d.children, function (x, k) { x.classList.toggle('is-on', k === Math.min(i, d.children.length - 1)); });
    };
    g.addEventListener('scroll', u, { passive: true }); addEventListener('resize', u); u();
  }

  /* 26 Eki: ürün kartı "Quick add" → Stiletto quick-view modalı.
     theme.js quick-view'u yalnız kendi bölümlerindeki (ürün ızgarası, shoppable-feature...) [data-quick-shop-trigger="quick-view"]
     butonlarına bağlar; tıklamada buttonEl.dataset.productUrl okuyup iç pub/sub ile ("quick-view:open") modalı açar; dışarıdan olay yok.
     Çözüm: sayfadaki bağlı bir butonu (Shop the look "Choose options") vekil kullan — data-product-url'i anlık değiştir, click(), geri al.
     Vekil ya da modal yoksa ürün sayfasına git (işlev kaybı yok). */
  function quickAdd(root) {
    root.querySelectorAll('.vm-card__qa').forEach(function (b) {
      if (!once(b, 'vmQa')) return;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var url = b.dataset.productUrl; if (!url) return;
        /* Swiper loop klonlarının (.swiper-slide-duplicate) dinleyicisi yok → adayları sırayla dene; handler preventDefault çağırır (= modal açıldı) */
        var cands = document.querySelectorAll('[data-quick-shop-trigger="quick-view"][data-product-url]');
        var modal = document.querySelector('[data-quick-view-modal]'), ok = false;
        if (modal) for (var i = 0; i < cands.length && !ok; i++) {
          var p = cands[i], old = p.dataset.productUrl; p.dataset.productUrl = url;
          var ev = new MouseEvent('click', { bubbles: false, cancelable: true });
          try { p.dispatchEvent(ev); } finally { p.dataset.productUrl = old; }
          ok = ev.defaultPrevented;
        }
        if (!ok) location.href = url;
      });
    });
  }

  /* ---------- ürün sayfası (vm-pdp) ---------- */
  function pdp(sec) {
    var D; try { D = JSON.parse(sec.querySelector('[data-pdp-json]').textContent); } catch (e) { return; }
    var q = function (s) { return sec.querySelector(s); }, qa = function (s) { return sec.querySelectorAll(s); };
    var pct = +sec.dataset.pct || 0, qty = 1;
    var form = q('[data-form]'), idIn = q('[data-id]'), gal = q('[data-gal]');
    var money = function (c) {
      var v = (c / 100).toFixed(2), f = D.money || '${{amount}}';
      return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/<[^>]+>/g, '');
    };
    var sale = function (c) { return pct ? c - Math.floor(c * pct / 100) : c; };  /* Shopify indirim tutarını aşağı yuvarlar */
    if (D.cur && !D.variants.some(function (x) { return x.id === D.cur.id; })) D.variants.push(D.cur);   /* 27 Eki: seçili varyant ilk 250'de olmayabilir */
    var sel = (function () { var v = D.variants.filter(function (x) { return x.id == idIn.value; })[0] || D.variants[0]; return v.o.slice(); })();
    /* 27 Eki: 250+ varyant (perde 648/1080) — Liquid tablosu 250'de kesik; bilinmeyen kombinasyon sunucuda çözülür
       (sections/vm-variant-resolver.liquid, 28 Tem: option_values=ID,ID,ID → selected_variant). Sonuç D.variants'a eklenir (id 0 = yok). */
    var RES = { ids: null, pend: {}, wait: {} };
    function resParse(h) { var doc = new DOMParser().parseFromString(h, 'text/html'); return JSON.parse(doc.querySelector('[data-vm-resolver]').textContent); }
    function resolverIds() {
      if (RES.ids) return Promise.resolve(RES.ids);
      return fetch('/products/' + D.handle + '?section_id=vm-variant-resolver', { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (h) {
        RES.ids = resParse(h).options.map(function (o) { var m = {}; o.values.forEach(function (v) { m[v.name] = v.id; }); return m; });
        return RES.ids;
      });
    }
    function findRemote(o) {
      var key = o.join('|'); if (RES.pend[key]) return RES.pend[key];
      RES.pend[key] = resolverIds().then(function (ids) {
        var ql = o.map(function (val, i) { return ids[i] && ids[i][val]; });
        if (ql.some(function (x) { return !x; })) return null;
        return fetch('/products/' + D.handle + '?section_id=vm-variant-resolver&option_values=' + ql.join(','), { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (h) {
          var j = resParse(h);
          var v = j.exact_match && j.variant ? { id: j.variant.id, o: o.slice(), p: j.variant.price, c: j.variant.compare_at_price || 0, a: !!j.variant.available, m: 0 } : { id: 0, o: o.slice(), p: 0, c: 0, a: false, m: 0 };
          if (!find(o)) D.variants.push(v);
          return v;
        });
      }).catch(function () { return null; });
      return RES.pend[key];
    }
    var find = function (o) { return D.variants.filter(function (v) { return v.o.every(function (x, i) { return x === o[i]; }); })[0]; };
    var slug = function (s) { return '-' + String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '-'; };

    qa('.vm-p__sw button').forEach(function (b) { if (!b.style.background) b.style.background = swatch(b.dataset.val); });

    function gallery(v) {
      var list = D.media;
      if (D.color > -1) {
        var s = slug(sel[D.color]);
        var f = D.media.filter(function (m) { return m.f.indexOf(s) > -1; });
        if (f.length) list = f;
      }
      if (v && v.m) {
        var fm = D.media.filter(function (m) { return m.id === v.m; })[0];
        if (fm) list = [fm].concat(list.filter(function (m) { return m.id !== fm.id; }));
      }
      list = list.slice(0, 10);
      gal.innerHTML = list.map(function (m, i) {
        return '<figure data-media-id="' + m.id + '"><img ' + (i ? 'loading="lazy" ' : '') + 'src="' + m.u.replace(/width=\d+/, 'width=' + (i ? 900 : 1600)) + '" alt="' + String(m.alt).replace(/"/g, '&quot;') + '"></figure>';
      }).join('');
      gal.scrollLeft = 0; galUpd(); galClamp();
      var st = q('[data-st-img]'); if (st && list[0]) st.src = list[0].u.replace(/width=\d+/, 'width=200');
    }
    function galUpd() {
      var n = gal.children.length, i = Math.round(gal.scrollLeft / (gal.clientWidth || 1));
      q('[data-count]').textContent = (Math.min(i, n - 1) + 1) + ' / ' + n;
      var d = q('[data-dots]'); if (d.children.length !== n) d.innerHTML = new Array(n + 1).join('<i></i>');
      Array.prototype.forEach.call(d.children, function (x, k) { x.classList.toggle('is-on', k === i); });
    }
    gal.addEventListener('scroll', galUpd, { passive: true });
    /* 27 Eki: galeri daralt/genişlet — ilk LIM fotoğraf (data-gal-limit, varsayılan 3); mobilde CSS tümünü gösterir */
    var LIM = +(gal.dataset.galLimit || 3), more = q('[data-galmore]');
    function galClamp() {
      var figs = gal.children, n = figs.length;
      Array.prototype.forEach.call(figs, function (f, i) { f.classList.toggle('is-extra', i >= LIM); });
      if (!more) return;
      more.hidden = n <= LIM;
      var open = !gal.classList.contains('is-clamped');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      q('[data-galmore-txt]').textContent = open ? 'Show less' : 'Show all ' + n + ' photos';
    }
    if (more) more.addEventListener('click', function () {
      var wasOpen = !gal.classList.contains('is-clamped');
      gal.classList.toggle('is-clamped', wasOpen);
      galClamp();
      if (wasOpen) window.scrollTo({ top: gal.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
    });
    galClamp();

    function render(changedColor) {
      var v = find(sel), key = sel.join('|'), pending = false;
      if (!v && D.capped) {
        pending = true;
        if (!RES.wait[key]) { RES.wait[key] = 1; findRemote(sel).then(function () { delete RES.wait[key]; render(changedColor); }); }
      }
      if (v && !v.id) v = null;   /* sunucu: bu kombinasyon yok */
      qa('[data-opt]').forEach(function (b) {
        var oi = +b.dataset.opt; b.setAttribute('aria-pressed', sel[oi] === b.dataset.val);
        var probe = sel.slice(); probe[oi] = b.dataset.val; var pv = find(probe);
        b.classList.toggle('is-out', pv ? (!pv.a || !pv.id) : !D.capped);   /* 250+: bilinmeyen = soluklaştırma */
        var sp = b.querySelector('[data-setprice]');
        if (sp) sp.innerHTML = pv && pv.id ? money(sale(pv.p)) + (pct ? '<s>' + money(pv.p) + '</s>' : '') : '';
      });
      qa('[data-sel]').forEach(function (s) { s.textContent = sel[+s.dataset.sel]; });
      /* 27 Eki: açılır liste seçenekleri — her değer için fiyat + stok durumu, seçili değeri eşitle */
      qa('[data-optsel]').forEach(function (s) {
        var oi = +s.dataset.optsel;
        Array.prototype.forEach.call(s.options, function (o) {
          var probe = sel.slice(); probe[oi] = o.dataset.val; var pv = find(probe);
          o.textContent = o.dataset.val + (pv ? (pv.id ? ' — ' + money(sale(pv.p)) + (pv.a ? '' : ' · Sold out') : ' — Unavailable') : (D.capped ? '' : ' — Unavailable'));
        });
        s.value = sel[oi];
      });
      var atc = qa('[data-atc], [data-st-atc]');
      if (!v) {
        atc.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = pending ? 'Checking…' : 'Unavailable'; });
        q('[data-price]').innerHTML = ''; return;
      }
      idIn.value = v.id;
      var s = sale(v.p), base = v.c > v.p ? v.c : v.p, pctShow = Math.round((1 - s / base) * 100);
      q('[data-price]').innerHTML = money(s) + (s < base ? ' <s>' + money(base) + '</s> <em>−' + pctShow + '%</em>' : '');
      qa('[data-atc-price]').forEach(function (b) { b.textContent = money(s * qty); });
      atc.forEach(function (b) { b.disabled = !v.a; b.querySelector('span').textContent = v.a ? 'Add to bag' : 'Sold out'; });
      var sub = q('[data-st-sub]'); if (sub) sub.textContent = sel.join(' · ');
      if (history.replaceState) history.replaceState(null, '', location.pathname + '?' + new URLSearchParams(Object.assign(Object.fromEntries(new URLSearchParams(location.search)), { variant: v.id })).toString());
      if (changedColor !== false) gallery(v);
    }
    qa('[data-opt]').forEach(function (b) {
      b.onclick = function () { var oi = +b.dataset.opt; sel[oi] = b.dataset.val; render(oi === D.color || !!(find(sel) || {}).m); };
    });
    qa('[data-optsel]').forEach(function (s) {
      s.onchange = function () { var oi = +s.dataset.optsel; sel[oi] = s.value; render(oi === D.color || !!(find(sel) || {}).m); };
    });
    qa('[data-q]').forEach(function (b) {
      b.onclick = function () { qty = Math.max(1, Math.min(20, qty + +b.dataset.q)); q('[data-qn]').textContent = qty; render(false); };
    });

    function add(e) {
      if (e) e.preventDefault();
      var btns = qa('[data-atc], [data-st-atc]'), err = q('[data-err]');
      btns.forEach(function (b) { b.disabled = true; });
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        // tekil gövde: toplu "items" biçimi olayı add-fetch-bulk yapıyor → Meta uygulama pikseli AddToCart göndermiyor (23 Eki)
        body: JSON.stringify({ id: +idIn.value, quantity: qty })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          err.hidden = true;
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
          q('[data-atc] span').textContent = 'Added ✓';
          var qv = sec.closest('[data-quick-view-modal]'); if (qv) { var qx = qv.querySelector('[data-modal-close]'); if (qx) qx.click(); }   /* 27 Eki: hızlı görünümden eklendiyse pencereyi kapat */
          var icon = document.querySelector('[data-js-cart-icon], .header__icon--cart, a[href$="/cart"]');
          setTimeout(function () { if (icon) icon.click(); q('[data-atc] span').textContent = 'Add to bag'; }, 500);
        })
        .catch(function (j) { err.textContent = (j && (j.description || j.message)) || 'Could not add to bag.'; err.hidden = false; })
        .then(function () { btns.forEach(function (b) { b.disabled = false; }); });
    }
    form.addEventListener('submit', add);
    var stb = q('[data-st-atc]'); if (stb) stb.onclick = add;   /* hızlı görünümde yapışkan çubuk yok */

    var sl = q('[data-size-link]');
    if (sl) sl.onclick = function (e) { /* VM SIZE GUIDE popup (26 Eki 2026) */
      e.preventDefault();
      var m = sec.querySelector('[data-size-modal]');
      if (m && m.showModal) { m.showModal(); return; }
      var s = sec.querySelector('#vm-size'); if (s) { s.open = true; s.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    };
    var sm = q('[data-size-modal]');
    if (sm) sm.addEventListener('click', function (e) { if (e.target === sm || e.target.closest('[data-size-close]')) sm.close(); });

    var sticky = q('[data-sticky]');
    if (sticky && q('[data-buy]') && 'IntersectionObserver' in window) new IntersectionObserver(function (es) {
      var e = es[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', !on); q('[data-st-atc]').tabIndex = on ? 0 : -1;
    }).observe(q('[data-buy]'));

    var lb = q('[data-lb]');
    if (lb) gal.addEventListener('click', function (e) {
      var f = e.target.closest('figure'); if (!f || matchMedia('(max-width:820px)').matches) return;
      lb.querySelector('img').src = f.querySelector('img').currentSrc.replace(/width=\d+/, 'width=2000'); lb.classList.add('is-on');
    });
    if (lb) { q('[data-lb-x]').onclick = function () { lb.classList.remove('is-on'); }; addEventListener('keydown', function (e) { if (e.key === 'Escape') lb.classList.remove('is-on'); }); }

    render(false); galUpd();
    var st = q('[data-st-img]'), f0 = gal.querySelector('img'); if (st && f0) st.src = f0.currentSrc || f0.src;
  }

  /* ---------- koleksiyon (vm-collection) ---------- */
  function collection(sec) {
    var form = sec.querySelector('[data-col-form]');
    /* filtre çubuğu temanın yapışkan başlığının altında dursun */
    var setTop = function () {
      var h = document.querySelector('.header__inner, [id$="__header"] .header, [id*="header"] header, header');
      var r = h ? h.getBoundingClientRect() : null;
      sec.style.setProperty('--vm-col-top', (r && r.bottom > 0 ? Math.round(r.bottom) : 0) + 'px');
    };
    setTop(); addEventListener('scroll', setTop, { passive: true }); addEventListener('resize', setTop);
    sec.querySelectorAll('.vm-col__panel i[data-c]').forEach(function (i) { if (!i.style.background) i.style.background = swatch(i.dataset.c); });
    var submit = function () {
      var p = new URLSearchParams(new FormData(form)); var out = new URLSearchParams();
      p.forEach(function (v, k) { if (v !== '') out.append(k, v); });
      location.href = form.getAttribute('action') + (out.toString() ? '?' + out.toString() : '');
    };
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    form.querySelectorAll('input[type=checkbox], [data-col-sort]').forEach(function (el) { el.addEventListener('change', submit); });
    var dets = sec.querySelectorAll('.vm-col__f');
    dets.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) dets.forEach(function (o) { if (o !== d) o.open = false; }); }); });
    document.addEventListener('click', function (e) { if (!e.target.closest('.vm-col__f')) dets.forEach(function (d) { d.open = false; }); });
    /* "Load more": sonraki sayfayı çekip kartları ekler (JS yoksa normal link) */
    sec.addEventListener('click', function (e) {
      var a = e.target.closest('[data-col-more]'); if (!a) return;
      e.preventDefault(); a.textContent = 'Loading…';
      fetch(a.href).then(function (r) { return r.text(); }).then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var g = doc.querySelector('[data-col-grid]'), grid = sec.querySelector('[data-col-grid]');
        if (g) Array.prototype.forEach.call(g.children, function (c) { grid.appendChild(document.importNode(c, true)); });
        dots(grid);
        var more = sec.querySelector('.vm-col__more'), nm = doc.querySelector('.vm-col__more');
        if (nm) more.replaceWith(document.importNode(nm, true)); else more.remove();
        if (history.replaceState) history.replaceState(null, '', a.href);
      }).catch(function () { location.href = a.href; });
    });
  }

  var INIT = { best: best, film: film, shade: shade, look: look, pdp: pdp, collection: collection };
  function init(scope) {
    (scope || document).querySelectorAll('[data-vm]').forEach(function (sec) {
      if (!once(sec, 'vmReady')) return;
      dots(sec); reveal(sec); quickAdd(sec);
      var f = INIT[sec.dataset.vm]; if (f) f(sec);
    });
  }
  /* 27 Eki: Stiletto quick-view modalı ?view=quick-view içeriğini (vm-pdp-quick) enjekte edince bizim pdp() bağlansın */
  function watchQuick() {
    var c = document.querySelector('[data-quick-view-modal] .quick-view-modal__content');
    if (c && 'MutationObserver' in window && once(c, 'vmWatch')) new MutationObserver(function () { init(c); }).observe(c, { childList: true });
  }
  window.vmHome = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); watchQuick(); }); else { init(); watchQuick(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
